import Button from '@codegouvfr/react-dsfr/Button';
import { FRANCE_COMPETENCES_URL, MINISTERE_TRAVAIL_URL } from '@common/config';
import { useOauth2Actions } from '@common/oauth2';
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LogoFC, LogoRF } from '../../../../shared/assets';
import './fc-header.css';

export const FcHeader = ({ navigationItems, hideLogoutButtonAndNavigation, isFc }: FcHeaderProps) => {
  const { logout, logoutWithRedirect } = useOauth2Actions();

  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(prev => !prev);

  return (

    <div>
      <div className={`overlay ${isOpen ? 'open' : ''}`}>
        <button className="close-btn" id="closeBtn" aria-label="Fermer" onClick={close}>
          <svg viewBox="0 0 16 16" fill="none">
            <line x1="2" y1="2" x2="14" y2="14"/>
            <line x1="14" y1="2" x2="2" y2="14"/>
          </svg>
        </button>
      <nav className="mobile-nav" role="navigation">
        <div className={'mb-8 disconnect-mobile'}>
          <Button onClick={() => isFc ? logout() : logoutWithRedirect()} priority={'tertiary no outline'} title={'Se déconnecter'} iconId={'fr-icon-account-circle-fill'}><span>Se déconnecter</span></Button>
        </div>
        {navigationItems && navigationItems.map(({ text, to }, index) => (
          <Link className={'link'} key={index} to={to}>{text}</Link>
        ))}
      </nav>
    </div>

  <header>
    <div className="header-top">
      <div className={'flex flex-row gap-8'}>
        <a target={'_blank'} href={MINISTERE_TRAVAIL_URL}>
          <img
            src={LogoRF as string}
            alt="Logo République Française"
            className="h-[60px]"
          />
        </a>
        <a target={'_blank'} href={FRANCE_COMPETENCES_URL}><img
          src={LogoFC as string}
          alt="Logo France compétences"
          className="h-[60px]"
        /></a>

      </div>

      {!hideLogoutButtonAndNavigation && !isOpen && <div className={'disconnect-desktop'}>
        <Button onClick={() => isFc ? logout() : logoutWithRedirect()} priority={'tertiary no outline'} title={'Se déconnecter'} iconId={'fr-icon-account-circle-fill'}><span>Se déconnecter</span></Button>
      </div>}

      {!hideLogoutButtonAndNavigation && <button className={`burger ${isOpen ? 'open' : ''}`} onClick={toggle}>
        <div className="burger-icon">
          <span></span><span></span><span></span>
        </div>
      </button>}
    </div>

    <nav className="desktop-nav">
      {navigationItems && navigationItems.map(({ text, to }, index) => (
        <NavLink
          key={index}
          to={to}
          className={({ isActive }) => isActive ? 'link active' : 'link'}
        >
          {text}
        </NavLink>
      ))}
    </nav>
  </header>
    </div>
  );
};

interface FcHeaderProps {
  navigationItems?: { text: string; to: string }[];
  hideLogoutButtonAndNavigation?: boolean;
  isFc?: boolean;
}